import MapView from '@arcgis/core/views/MapView';
import Graphic from '@arcgis/core/Graphic';
import {
  addLabelForGraphic, buildGraphic, buildLabelFromGraphicWithShape,
  findGraphicIdOnMapView, removeTextLabelGraphics, updateGraphicColor,
  updateGraphicGeometry, updateGraphicSymbol,
} from '../../../sketch-editor/graphics-handler';
import { GraphicStyle } from '../../../sketch-editor/graphic-styles';

const SET_OFF = false;
const SET_ON = true;

export interface Highlighter {
  highlightGraphic: (graphic: Graphic | null, color: string) => void;
  handleRowHover: (record: Record<string, any> | undefined, mapView: MapView, color: string) => void;
  reset: () => void;
}

const GraphicHighlighter = () => {
  let lastHoveredGraphic: Graphic | null;
  let lastRowHoveredFeature: Record<string, any> | undefined;

  const setGraphicHoverState = (graphic: Graphic | null, hovered: boolean, color: string) => {
    if (!graphic?.attributes) return;
    if (hovered) {
      const newGraphic = buildGraphic(graphic.attributes.shape, color, GraphicStyle.TARGET_GEOMETRY);
      updateGraphicSymbol(graphic, newGraphic.symbol as unknown as Symbol);
      updateGraphicGeometry(graphic, newGraphic.geometry);
    } else if (graphic?.symbol?.color) {
      updateGraphicColor(graphic, color);
    }
  };

  const highlightGraphic = (graphic: Graphic | null, color) => {
    if (lastHoveredGraphic) {
      if (lastHoveredGraphic?.attributes?.shape?.item?._id !== graphic?.attributes?.shape?.item?._id) {
        setGraphicHoverState(lastHoveredGraphic, SET_OFF, color);
        lastHoveredGraphic = graphic;
        setGraphicHoverState(lastHoveredGraphic, SET_ON, color);
      }
    } else {
      lastHoveredGraphic = graphic;
      setGraphicHoverState(lastHoveredGraphic, SET_ON, color);
    }
  };

  const handleRowHover = (record: Record<string, any> | undefined, mapView: MapView, color) => {
    if (lastRowHoveredFeature?._id !== record?._id) {
      if (lastRowHoveredFeature) {
        const lastGraphic = findGraphicIdOnMapView(mapView, lastRowHoveredFeature._id);
        setGraphicHoverState(lastGraphic, SET_OFF, color);
      }
      lastRowHoveredFeature = record;

      if (record) {
        const graphic = findGraphicIdOnMapView(mapView, record._id);
        if (graphic) {
          const labelText = buildLabelFromGraphicWithShape(graphic);
          removeTextLabelGraphics(mapView);
          addLabelForGraphic(mapView, graphic, labelText);
          highlightGraphic(graphic, color);
        }
      } else {
        setGraphicHoverState(lastHoveredGraphic, SET_OFF, color);
        removeTextLabelGraphics(mapView);
        lastHoveredGraphic = null;
      }
    }
  };

  const reset = () => {
    lastHoveredGraphic = null;
    lastRowHoveredFeature = undefined;
  };

  return {
    highlightGraphic,
    handleRowHover,
    reset,
  };
};

export default GraphicHighlighter;
